import { makeStyles } from '@material-ui/core/styles';

export const useErrorStateStyles = makeStyles((theme) => ({
  container: {
    width: (props) => (props.mobile ? '255px' : '390px'),
    height: (props) => (props.mobile ? '183px' : '205px'),
    background: '#f1f1f1',
    borderRadius: 10,
    marginBottom: 10,
    padding: (props) =>
      props.mobile ? '20px 77px 20px 20px' : '35px 120px 35px 40px',
    boxSizing: 'border-box',
    position: 'relative',
    margin: (props) =>
      props.mobile ? '20px 0px 0px 0px' : '100px 0px 0px 60px',
  },
  boldText: {
    fontSize: 'inherit',
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  regularText: {
    fontSize: (props) => (props.mobile ? 16 : 18),
  },
  image: {
    position: 'absolute',
    top: (props) => (props.mobile ? '3%' : '-35px'),
    left: (props) => (props.mobile ? '70%' : '275px'),
    height: (props) => (props.mobile ? '90%' : '253px'),
  },
}));
